/**
 * SearchBar Molecule Component
 * Search input for filtering cars
 */

'use client'

import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { cn } from '@/lib/utils'
import { Search, X } from 'lucide-react'
import React from 'react'

interface SearchBarProps {
	value: string
	onChange: (value: string) => void
	onSearch?: () => void
	placeholder?: string
	className?: string
}

export function SearchBar({
	value,
	onChange,
	onSearch,
	placeholder = 'Buscar carros por marca, modelo...',
	className,
}: SearchBarProps) {
	const handleClear = () => {
		onChange('')
	}

	const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
		if (e.key === 'Enter' && onSearch) {
			onSearch()
		}
	}

	return (
		<div className={cn('relative flex items-center gap-2', className)}>
			<div className='relative flex-1'>
				<Search className='absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400' />

				<Input
					type='text'
					value={value}
					onChange={e => onChange(e.target.value)}
					onKeyDown={handleKeyDown}
					placeholder={placeholder}
					className='pl-10 pr-10'
				/>

				{value && (
					<button
						onClick={handleClear}
						className='absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 cursor-pointer'
						aria-label='Limpiar búsqueda'
					>
						<X className='w-5 h-5' />
					</button>
				)}
			</div>

			{onSearch && (
				<Button
					onClick={onSearch}
					className='bg-[#09194D] hover:bg-[#09194D]/90 cursor-pointer'
				>
					Buscar
				</Button>
			)}
		</div>
	)
}
